export enum DashboardServiceGroupEnum {
  inAuction = 'InAuction',
  manualCompleted = 'ManualCompleted',
  inMarket = 'InMarket',
  assigned = 'Assigned',
  unAssigned = 'Unassigned',
  started = 'Started',
  aborted = 'Aborted',
  completed = 'Completed',
  canceled = 'Canceled',
  late = "Late",
  risk = "Risk"
}
